import { SORT_DATE, SORT_NAME } from 'constants/sortConstants';

export const EVENT_LIST_OPTIONS = [
  {
    value: SORT_DATE,
    label: 'À venir'
  },
  {
    value: SORT_NAME,
    label: 'Ordre alphabétique'
  }
];

export const LABEL_CALENDAR_TEAM = "Calendrier des équipes";
export const LABEL_CALENDAR_INSTITUTIONNEL = "Calendrier fédéral";
export const FILTER_COMPETITION = 'competition';
export const FILTER_COMPETITION_AMATEUR = 'competitions-amateurs';
export const FILTER_TRAINING = 'entrainement';
export const FILTER_INSTITUTIONNEL = 'institutionnel';
export const EVENTS_SLUG_TYPE_MATCH = [];
export const EVENT_NAVBAR_SIZE_MOBILE = 1280;
